import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'portals-pcc-icon',
  templateUrl: './pcc-icon.component.html',
  styleUrls: ['./pcc-icon.component.scss']
})
export class PccIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
